import Meta from '@/components/common/Meta'

import GolfBagsStoragesServicesNearMePage from '@/v2/components/pages/landing-pages/golf-bags-storages-services-near-me-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/golf-bags-storages-services-near-me-page'

interface GolfBagsStoragesServicesNearMePageProps {}

const Page: React.FC<GolfBagsStoragesServicesNearMePageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.golf_bags_storages_services_near_me.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.golf_bags_storages_services_near_me?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.golf_bags_storages_services_near_me?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <GolfBagsStoragesServicesNearMePage />
    </>
  )
}

export default Page
